<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Processing...">
  </mat-progress-bar>
</section>

<section *ngIf="!loading && !processing">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <span *ngIf="treatmentId > 0">
          <mat-icon>edit</mat-icon> Edit Treatment Id: {{treatmentId}}
        </span>
        <span *ngIf="treatmentId == 0">
          <mat-icon>add</mat-icon> Add Treatment to Housing Unit Id:
          {{housingUnitId}}
        </span>
      </h2>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <button type="submit" (click)="saveTreatment()" mat-raised-button color="primary" title="{{buttonText}}" [disabled]="authService.isReadOnly()">
        {{buttonText}}
      </button>
      &nbsp;&nbsp;
      <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic" title="Close">
        Close
      </button>
    </div>
  </div>
</section>

<mat-dialog-content [hidden]="loading || processing">
  <div fxLayout="row wrap" fxLayoutGap="8px grid" fxFlex="100" fxFlex.lt-sm="100" *ngIf="housingUnit">
    <div fxFlex=" 100" fxFlex.lt-sm="100">
      <mat-card>
        <div fxLayout="row wrap">
          <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col">
            <strong>Housing Unit Address</strong><br />{{housingUnit.address1}}
            {{housingUnit.address2}} {{housingUnit.city}}
          </div>
          <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col">
            <strong>Housing Unit County</strong><br />{{housingUnit.county}}
          </div>
          <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col">
            <strong>Housing Unit Mailing Address</strong><br />{{housingUnit.mailingAddress}} {{housingUnit.mailingCity}}
          </div>
          <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col">
            <strong>Shared Well</strong><br />
            <span *ngIf="treatmentData.sharedWell">Yes</span>
            <span *ngIf="!treatmentData.sharedWell">No</span>
          </div>
        </div>
        <div fxLayout="row wrap">
          <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col">
            <strong>Date of First Tier 3 Sample</strong><br />{{treatmentData.dateOfFirstTier3Sample}}
          </div>
          <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col">
            <strong>Highest Nitrate Test Result (mg/L)</strong><br />{{treatmentData.highestNitrateTestResult}}
          </div>
          <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col">
            <strong>Date of Highest Nitrate Result</strong><br />{{treatmentData.dateOfHighestNitrateResult}}
          </div>
          <div fxFlex="25.00" fxFlex.lt-sm="100" class="matero-col">
            <strong>Last Sample Collection Date</strong><br />{{treatmentData.lastSampleCollectionDate}}
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
    <form #form="ngForm" [formGroup]="treatmentForm" class="form-field-full">
      <div fxLayout="row wrap" fxLayoutGap="8px grid">
        <div fxFlex="33" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>Assigned Partner</mat-label>
            <mat-select id="assignedPartnerId" name="assignedPartnerId" formControlName="assignedPartnerId" (selectionChange)="populateInstalledByOptions()">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of partners" value="{{item.id}}">{{item.partnerName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>Status of Install</mat-label>
            <mat-select id="statusOfInstall" name="statusOfInstall" formControlName="statusOfInstall">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of housingUnitService.statusOfInstallOptions" value="{{item}}">{{item}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>Completion Date</mat-label>
            <input id="treatmentInstallCompletionDate" name="treatmentInstallCompletionDate" formControlName="treatmentInstallCompletionDate" placeholder="mm/dd/yyyy" matInput
              [matDatepicker]="datepickerTreatmentInstallCompletionDate" />
            <mat-datepicker-toggle matSuffix [for]="datepickerTreatmentInstallCompletionDate"></mat-datepicker-toggle>
            <mat-datepicker #datepickerTreatmentInstallCompletionDate>
              <mat-datepicker-actions>
                <button mat-raised-button color="primary" matDatepickerApply>
                  Apply
                </button>
                <button mat-button matDatepickerCancel>Cancel</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="8px grid">
        <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>System Installation Priority</mat-label>
            <mat-select id="systemInstallationPriority" name="systemInstallationPriority" formControlName="systemInstallationPriority">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of housingUnitService.systemInstallPriorityOptions" value="{{item}}">{{item}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>Installed By</mat-label>
            <mat-select id="installedBy" name="installedBy" formControlName="installedBy" [disabled]='assignedPartner == null'>
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of installedByOptions" value="{{item.passKey}}">{{item.passKey}} - {{item.comments}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="33.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>OHA System Installed</mat-label>
            <mat-select id="systemInstalled" name="systemInstalled" formControlName="systemInstalled">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of housingUnitService.systemInstalledOptions" value="{{item}}">{{item}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="8px grid">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>Existing Treatment System</mat-label>
            <mat-select id="existingTreatmentSystem" name="existingTreatmentSystem" formControlName="existingTreatmentSystem"
              (selectionChange)="disableEnableInput(treatmentForm.get('existingTreatmentSystem').value)">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of housingUnitService.existingTreatmentSystemOptions" value="{{item}}">{{item}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>Describe Existing System</mat-label>
            <input matInput placeholder="Describe Existing System" id="describeExistingSystem" name="describeExistingSystem" formControlName="describeExistingSystem" />
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="8px grid">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <div style="padding-top: 27px">
            <mat-checkbox id="roSystemRefused" name="roSystemRefused" formControlName="roSystemRefused">
              RO System declined/Unable to install</mat-checkbox>
          </div>
        </div>

        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-form-field appearance="standard">
            <mat-label>Reason for Decline</mat-label>
            <mat-select id="reasonForRefusal" name="reasonForRefusal" formControlName="reasonForRefusal" (selectionChange)="disableEnableInput(treatmentForm.get('reasonForRefusal').value)">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let item of housingUnitService.reasonForRefusalOptions" value="{{item}}">{{item}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <br />
      <br />
      <!-- Post treatment samples -->
      <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="treatment.treatmentSamples.length > 0">
        <div fxFlex="100" fxFlex.lt-sm="100">
          <mat-card fxFlex="100" fxFlex.lt-sm="100" fxLayout="column" fxLayoutGap="8px">
            <mat-card-title class="f-s-12 f-w-100">Post Treatment Samples</mat-card-title>
            <div *ngFor="let item of treatment.treatmentSamples; let i = index;">
              <div fxFlex="100" fxFlex.lt-sm="100" fxLayout="row wrap">
                <div fxFlex="25" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                  <strong>Sample Collection Date:</strong>
                  {{item.collectionDate}}
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                  <strong>Nitrate Result:</strong> {{item.result}}
                  {{item.unitShortDesc}}
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                  <strong>Sample Id:</strong> {{item.sampleId}}
                </div>
                <div fxFlex="25" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                  &nbsp;&nbsp;
                  <a href="javascript:void(0)" (click)="unlinkSample(i, item.sampleId)" title="Unlink Sample" mat-button color="warn"><mat-icon>delete</mat-icon></a>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="8px grid" *ngIf="treatment.treatmentId > 0 && treatment.treatmentSamples.length == 0">
        <div fxFlex="100" fxFlex.lt-sm="100">
          <mat-card fxFlex="100" fxFlex.lt-sm="100" fxLayout="column" fxLayoutGap="8px">
            <mat-card-title class="f-s-12 f-w-100">Post Treatment Samples</mat-card-title>
            <a href="javascript:void(0)" (click)="linkSample()" title="Link a Sample" mat-button color="warn">Link a Sample</a>
          </mat-card>
        </div>
      </div>
    </form>

    <br />
    <br />

    <div fxLayout="row wrap" fxLayoutGap="8px grid">
      <div fxFlex="100" fxFlex.lt-sm="100">
        <mat-card fxFlex="100" fxFlex.lt-sm="100" fxLayout="column" fxLayoutGap="8px">
          <mat-card-title class="f-s-12 f-w-100">Contacts</mat-card-title>
          <div *ngFor="let item of contacts; let i = index;">
            <div fxFlex="100" fxFlex.lt-sm="100" fxLayout="row wrap" *ngIf="item.status != 'deleted'">
              <div fxFlex="20" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start" style="padding: 8px;">
                <mat-form-field appearance="standard">
                  <mat-label>Date of Contact</mat-label>
                  <input placeholder="Date of First Contact" matInput id="dateOfContact{{i}}" name="dateOfContact{{i}}" [matDatepicker]="datepickerDateOfContact" [(ngModel)]="item.dateOfContact" />
                  <mat-datepicker-toggle matSuffix [for]="datepickerDateOfContact"></mat-datepicker-toggle>
                  <mat-datepicker #datepickerDateOfContact>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>
                        Apply
                      </button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start" style="padding: 8px;">
                <mat-form-field appearance="standard" fxFlex="100">
                  <mat-label>Contacted By</mat-label>
                  <mat-select [(ngModel)]="item.contactedBy" placeholder="Contacted By" id="contactedBy{{i}}" name="contactedBy{{i}}">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of housingUnitService.installedByOptions" value="{{item}}">{{item}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start" style="padding: 8px;">
                <mat-form-field appearance="standard" fxFlex="100">
                  <mat-label>Outcome</mat-label>
                  <input [(ngModel)]="item.outcome" placeholder="Outcome" id="outcome{{i}}" matInput type="text" />
                </mat-form-field>
              </div>
              <div fxFlex="10" fxFlex.lt-sm="100" fxLayout="column-reverse" fxLayoutAlign="start center">
                <a href="javascript:void(0)" (click)="deleteContact(i, item.treatmentContactId)" title="Remove" mat-button color="warn"
                  *ngIf="!authService.isReadOnly()"><mat-icon>cancel</mat-icon></a>
              </div>
            </div>
          </div>

          <div fxFlex="100" fxLayout="row wrap" fxLayoutGap="8px">
            <button type="button" (click)="addContact()" title="Add Contact" mat-raised-button color="primary" [disabled]="authService.isReadOnly()">
              Add Contact <mat-icon>add</mat-icon>
            </button>
          </div>
        </mat-card>
      </div>
    </div>

    <br />
    <br />

    <div fxLayout="row wrap" fxLayoutGap="8px grid">
      <div fxFlex="100" fxFlex.lt-sm="100">
        <mat-card fxFlex="100" fxFlex.lt-sm="100" fxLayout="column" fxLayoutGap="8px">
          <div *ngFor="let item of notes; let i = index;">
            <div fxFlex="100" fxFlex.lt-sm="100" fxLayout="row wrap" *ngIf="item.status != 'deleted'">
              <div fxFlex="90" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                <mat-form-field appearance="standard" fxFlex="100">
                  <mat-label>Notes</mat-label>
                  <textarea matInput placeholder="Notes" rows="3" [(ngModel)]="notes[i].comments" id="item.comment{{i}}" name="item.comment{{i}}" value="{{notes[i].comments}}"></textarea>
                </mat-form-field>
              </div>
              <div fxFlex="10" fxFlex.lt-sm="100" fxLayout="column-reverse" fxLayoutAlign="start center">
                <a href="javascript:void(0)" (click)="deleteNote(i, item.treatmentNoteId)" title="Remove" mat-button color="warn" *ngIf="!authService.isReadOnly()"><mat-icon>cancel</mat-icon></a>
              </div>
            </div>
          </div>

          <div fxFlex="100" fxLayout="row wrap" fxLayoutGap="8px">
            <button type="button" (click)="addNote()" title="Add Note" mat-raised-button color="primary" [disabled]="authService.isReadOnly()">
              Add Note <mat-icon>add</mat-icon>
            </button>
          </div>
        </mat-card>
      </div>
    </div>

    <br />
    <br />

    <div fxLayout="row wrap" fxLayoutGap="8px grid">
      <div fxFlex="100" fxFlex.lt-sm="100">
        <mat-card fxFlex="100" fxFlex.lt-sm="100" fxLayout="column" fxLayoutGap="8px">
          <mat-card-title class="f-s-12 f-w-100">Filter Changes</mat-card-title>
          <div *ngFor="let item of filterChanges; let i = index;">
            <div fxFlex="100" fxFlex.lt-sm="100" fxLayout="row wrap" *ngIf="item.status != 'deleted'">
              <div fxFlex="20" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                <mat-form-field appearance="standard">
                  <mat-label>Filter Change Date</mat-label>
                  <input placeholder="Filter Change Date" matInput id="filterChangeDate{{i}}" name="filterChangeDate{{i}}" [matDatepicker]="datepickerFilterChangeDate"
                    [(ngModel)]="item.filterChangeDate" />
                  <mat-datepicker-toggle matSuffix [for]="datepickerFilterChangeDate"></mat-datepicker-toggle>
                  <mat-datepicker #datepickerFilterChangeDate>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>
                        Apply
                      </button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                <mat-form-field appearance="standard" fxFlex="100">
                  <mat-label>Comments</mat-label>
                  <input [(ngModel)]="item.comments" placeholder="Comments" id="comments{{i}}" matInput type="text" />
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                <mat-form-field appearance="standard" fxFlex="100">
                  <mat-select [(ngModel)]="item.passKey" id="passKey{{i}}" name="passKey{{i}}" placeholder="Filter Change By" [disabled]='assignedPartner == null'>
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of installedByOptions" value="{{item.passKey}}">{{item.passKey}} - {{item.comments}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="10" fxFlex.lt-sm="100" fxLayout="column-reverse" fxLayoutAlign="start center">
                <a href="javascript:void(0)" (click)="deleteFilterChange(i, item.treatmentFilterChangeId)" title="Remove" mat-button color="warn"
                  *ngIf="!authService.isReadOnly()"><mat-icon>cancel</mat-icon></a>
              </div>
            </div>
          </div>

          <div fxFlex="100" fxLayout="row wrap" fxLayoutGap="8px">
            <button type="button" (click)="addFilterChange()" title="Add Filter Change" mat-raised-button color="primary" [disabled]="authService.isReadOnly()">
              Add Filter Change <mat-icon>add</mat-icon>
            </button>
          </div>
        </mat-card>
      </div>
    </div>

  </div>
</mat-dialog-content>